<template>
  <div style="width:100%;height:calc(100% - 40px);box-sizing:border-box;">
    <div id="macarons" style="width:100%;height:100%;" />
  </div>
</template>

<script>
export default {
  props: {
    source: {
      type: Array,
      default: [],
    },
    // legend: {
    //   type: Array,
    //   default: [],
    // },
    // radius: {
    //   type: [Array, Number],
    //   default: [75, 90],
    // },
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
  },
  data() {
    return {
      chart: "",
      radius: ['50%', "65%"],
      totalNum: 0,
    };
  },
  watch: {
    source: {
      deep: true,
      handler(val) {
        // console.log("val", val);
        let sum = 0;
        val.forEach(item=>{
          sum+= item.value
        })
        this.totalNum = sum;
        this.initChart(val);
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      if(this.source) {
        this.initChart();
      }
    });
  },

  methods: {
    initChart() {
      let that = this;
      const legend_rich = {
        a: {
          fontSize: 14,
          color: '#fff',
          width: 100,
          align: 'left',
          padding: [0, 0, 0, 10],
        },

        b: {
          fontSize: 14,
          fontWeight: 'normal',
          color: '#fff',
          align: 'right',
          padding: [0, 0, 0, 10],
          lineHeight: 25,
        },
      }

      const color_arr = [
        "#f99b79",
        "#ff4500",
        "#ff8c00",
        "#90ee90",
        "#1e90ff",
      ]

      const total = that.source.reduce((total, item) => {
        return total + item.value
      }, 0)

      this.chart = this.$echarts.init(document.getElementById("macarons"));
      let options = {
        color: color_arr,
        legend: {
          show: true,
          right: 0,
          top: 'center',
          itemWidth: 10,
          itemHeight: 10,
          icon: 'circle',
          width: 100,

          textStyle: {
            color: 'auto',
            rich: legend_rich,
            fontWeight: 'normal'
          },

          formatter: function (name){
            if (!name) {
              return ''
            }
            let cur_item = that.source.find(item => {
              return item.name == name
            })

            const scale = isNaN(cur_item.value / total) ? 0 : (cur_item.value * 100 / total).toFixed(2)

            return  '{a|'+ name +'} {b|' + cur_item.value + "个" + '\xa0' + '\xa0' + scale + "%" + '}'
          },
        },
        tooltip: {
          trigger: "item",
          backgroundColor: 'rgba(255,255,255,0.15)',
          borderColor: '#00D7FE',
          textStyle: {
            color: 'white',
            fontSize: 14,
            fontWeight: 'normal'
          },
          formatter: "{b}<br/> 数量：{c} <br/> 占比：{d}%",
          // formatter: function (value) {
          //   let data = value.data
          //   return (
          //     data.name +
          //     "<br/>" +
          //     "数量：" +
          //     data.value +
          //     "<br/>" +
          //     "占比：" +
          //     data.scale + '%'
          //   );
          // },
          type: "pie",
        },
        title: [
          {
            // text: that.GLOBAL.unitConversionSplit(that.totalNum).val+that.GLOBAL.unitConversionSplit(that.totalNum).unit + "人",
            text: total + '人',
            left: "23%",
            top: "35%",
            textStyle: {
              fontSize: 24,
              color: "#00ffff",
              fontWeight: "800",
            },
          },
          {
            text: "成员总数",
            left: '23%',
            top: '50%',
            textStyle: {
              fontSize: 16,
              color: "#fff",
              fontWeight: "normal",
            },
          },
        ],
          // tooltip: {
          //   trigger: "item",
          //   formatter: "{b}<br/> 数量：{c} <br/> 占比：{d}%",
          // },
        // title: {
        //   text: that.GLOBAL.unitConversionSplit(that.totalNum).val+that.GLOBAL.unitConversionSplit(that.totalNum).unit+'人',
        //   subtext: '成员总数',
        //   left: "49%",
        //   top: "36%",
        //   textAlign: "center",
        //   textStyle: {
        //     color: "#333",
        //     fontSize: 18,
        //   },
        //   subtextStyle:{
        //     color: "#333",
        //     fontSize: 14,
        //   }
        // },
          // legend: {
          //   orient: "horizontal", //horizontal
          //   left: 'center',
          //   bottom: 0,
          //   // itemWidth: 14,
          //   // itemHeight: 9,
          //   textStyle:{
          //     fontSize: 12,
          //   },
          //   data: this.legend,
          //   type: 'scroll',
          // },
          // series: [
          //   {
          //     name: "",
          //     type: "pie",
          //     radius: this.radius,
          //     center: ["center", "42%"],
          //     avoidLabelOverlap: true,
          //     label: {
          //       normal:{
          //         show: false,
          //       }
          //     },
          //     emphasis: {
          //       label: {
          //         show: true,
          //         fontSize: "30",
          //         fontWeight: "bold",
          //       },
          //     },
          //     labelLine: {
          //       show: false,
          //     },
          //     data: this.source,
          //     itemStyle: {
          //       normal: {
          //         color: function (params) {
          //           //自定义颜色
          //           var colorList = [
          //             "#f99b79",
          //             "#ff4500",
          //             "#ff8c00",
          //             "#1e90ff",
          //           ];
          //           return colorList[params.dataIndex];
          //         },
          //       },
          //     },
          //   },
          // ],
          // label: {
          //       normal: {
          //           show: false
          //       },
          //       emphasis: {
          //           show: true
          //       }
          //   },
          //   lableLine: {
          //       normal: {
          //           show: false
          //       },
          //       emphasis: {
          //           show: true
          //       }
          //   },
          series: [
            {
              type: "pie",
              radius: ['60%', '75%'],
              center: ['30%', '50%'],
              hoverAnimation: false,
              avoidLabelOverlap: false,
              label: {
                normal: {
                  show: false
                },
                emphasis: {
                  show: false
                },
                position: 'center'
              },
              emphasis: {
                label: {
                  show: false,
                  fontSize: '40',
                  fontWeight: 'bold'
                }
              },
              lableLine: {
                normal: {
                  show: false
                },
                emphasis: {
                  show: false
                }
              },
              data: this.source,
            },
            {
              type: 'pie',
              radius: ['52%', '65%'],
              center: ['30%', '50%'],
              hoverAnimation: false,
              avoidLabelOverlap: false,
              itemStyle: {
                opacity: 0.6,
              },
              label: {
                normal: {
                  show: false
                },
                emphasis: {
                  show: false
                },
                position: 'center'
              },
              emphasis: {
                label: {
                  show: false,
                  fontSize: '40',
                  fontWeight: 'bold'
                }
              },
              lableLine: {
                normal: {
                  show: false
                },
                emphasis: {
                  show: true
                }
              },
              data: this.source,
            },
            {//内部虚线圆环
              name: 'decorationOne',
              type: 'pie',
              color: ['rgba(255,255,255,0.2)', 'rgba(255,255,255,0)'],
              radius: ['46%', '48%'],
              center: ['30%', '50%'],
              hoverAnimation: false,
              itemStyle: {
                opacity: 0.8,
              },
              label: {
                normal: {
                  show: false
                },
                emphasis: {
                  show: false
                },
                position: 'center'
              },
              emphasis: {
                label: {
                  show: false,
                  fontSize: '40',
                  fontWeight: 'bold'
                }
              },
              lableLine: {
                normal: {
                  show: false
                },
                emphasis: {
                  show: true
                }
              },
              silent: true,
              tooltip: {
                show: false,
              },
              data: new Array(100).fill(10).map(() => {
                return {
                  name: '',
                  value: 20,
                };
              }),
            },
          ],
      }

      setTimeout(() => {
        that.chart.setOption(options);
        // this.pieChart.setOption(this.myOption);
        that.chart.resize();
        window.addEventListener("resize", that.chart.resize);
      }, 300);
    },
  },
};
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/studio/homepage/home/homeleftbottom.vue